import { http } from "src/common/http";
import { CouponParam } from "src/module/coupon/param/coupon.param";

class SubscriptionCouponService {
	list = async (param: CouponParam) => {
		return http({
			url: process.env.REACT_APP_GO_API + "/api/v1/admin/subscription-coupon",
			method: "GET",
			params: param,
		});
	};
	detail = async (id: number) => {
		return http({
			url: process.env.REACT_APP_GO_API + "/api/v1/admin/subscription-coupon/" + id,
			method: "GET",
		});
	};
	delete = async (id: number) => {
		return http({
			url: process.env.REACT_APP_GO_API + "/api/v1/admin/subscription-coupon/" + id,
			method: "DELETE",
		});
	};
	update = async (id: number, param: CouponParam) => {
		return http({
			url: process.env.REACT_APP_GO_API + "/api/v1/admin/subscription-coupon/" + id,
			method: "PUT",
			data: param,
		});
	};
	add = async (param: CouponParam) => {
		return http({
			url: process.env.REACT_APP_GO_API + "/api/v1/admin/subscription-coupon",
			method: "POST",
			data: param,
		});
	};
}
export default new SubscriptionCouponService();
